<template>
    <div>
        <el-table
            ref="a2p-trust-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-email="true"
                        :show-a2p-brand="true"
                        :show-customer-profile="true"
                        name-field="friendly_name"
                    />
                </template>
            </el-table-column>

            <!-- Timestamps Column -->
            <el-table-column
                label="Timestamps"
                width="140"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Type Column -->
            <el-table-column
                label="Type"
                prop="type"
                width="120"
            >
                <template v-slot="scope">
                    <TypeColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Status Column -->
            <el-table-column
                label="Status"
                prop="status_name"
                width="120"
            >
                <template v-slot="scope">
                    <StatusColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Attributes Column -->
            <el-table-column
                label="Attributes"
                width="450"
            >
                <template v-slot="scope">
                    <AttributesColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Failure Reason Column -->
            <el-table-column
                label="Failure reason"
                prop="failure_reason"
            >
                <template v-slot="scope">
                    <FailureReasonColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Action"
                width="150"
            >
                <template v-slot="scope">
                    <div>
                        <el-tooltip
                            placement="top"
                            content="This bundle is already in use."
                            :disabled="!disableUseThisBundleButton(scope.row)"
                        >
                            <el-button
                                type="success"
                                size="mini"
                                class="btn-block"
                                @click="handleUseBundle(scope.row)"
                                :loading="loadingUpdateBundle.includes(scope.row.id)"
                                :disabled="disableUseThisBundleButton(scope.row)"
                            >
                                Use this bundle
                            </el-button>
                        </el-tooltip>
                    </div>
                    <div v-if="!isReseller" class="mt-1">
                        <el-button
                            type="primary"
                            size="mini"
                            class="btn-block"
                            @click="handleViewDetails(scope.row)"
                        >
                            View details
                        </el-button>
                    </div>
                    <div class="mt-1">
                        <el-button
                            type="danger"
                            size="mini"
                            class="btn-block"
                            @click="handleDeleteBundle(scope.row)"
                            :loading="loadingDeleteBundle.includes(scope.row.id)"
                        >
                            Delete
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { compliance_mixin, acl_mixin } from '../../../mixins'
import InformationColumn from '../columns/information-column'
import TimestampsColumn from '../columns/timestamps-column'
import TypeColumn from '../columns/type-column'
import StatusColumn from '../columns/status-column'
import FailureReasonColumn from '../columns/failure-reason-column'
import AttributesColumn from '../columns/attributes-column'

export default {
    name: 'A2pTrustBundleTable',
    components: {
        InformationColumn,
        TimestampsColumn,
        TypeColumn,
        StatusColumn,
        FailureReasonColumn,
        AttributesColumn,
    },
    mixins: [compliance_mixin, acl_mixin],
    props: {
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        bundles: {
            type: Array,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            deleteTooltip: null,
        }
    },
    methods: {
        disableUseThisBundleButton(compliance_bundle) {
            return compliance_bundle && compliance_bundle.in_use
        },
        handleUseBundle(bundle) {
            this.$emit('use-bundle', bundle)
        },
        handleViewDetails(bundle) {
            this.$emit('view-details', bundle)
        },
        handleDeleteBundle(bundle) {
            this.$emit('delete-bundle', bundle)
        },
    },
}
</script>
